/**
 * Finds the maximum time from an array of time strings.
 *
 * @param {string[]} times - An array of time strings in the format "HH:MM:SS".
 * @returns {string} The maximum time string.
 * @throws {Error} If the input is not a non-empty array of time strings.
 */
export function findMaxTime(times) {
    if (!Array.isArray(times) || times.length === 0) {
        throw new Error("Input should be a non-empty array of time strings.");
    }

    return times.reduce((maxTime, currentTime) => {
        return convertToTime(currentTime) > convertToTime(maxTime) ? currentTime : maxTime;
    });
}


/**
 * Converts a time string to a JavaScript Date object.
 * @param {string} timeString - The time string in the format "HH:MM:SS".
 * @returns {Date} The JavaScript Date object representing the given time.
 */
function convertToTime(timeString) { //Helper function
    const [hours, minutes, seconds = 0] = timeString.split(':').map(Number);
    const date = new Date();
    date.setHours(hours, minutes, seconds, 0);
    return date;
}
